import React from 'react';
import ReactDOM from 'react-dom';
import { clientsSuffix } from 'servicesCommon/config';

import BaseApp from 'components/BaseApp/BaseApp';
import RestrictedApp from 'AppClient/routes/RestrictedApp';

const renderClientApp = () => {
	ReactDOM.render(
		<BaseApp basename={clientsSuffix}>
			<RestrictedApp />
		</BaseApp>,
		document.getElementById('app')
	);
};
export default renderClientApp;
